import moment from 'moment';

const PICKER_DATE_TEXT = /^[A-Z][a-z]{2} [A-Z][a-z]{2} \d{2} \d{4} \d{2}:\d{2}:\d{2}/;

export const pickerDisplayValue = (value: unknown, format = 'MM/DD/YYYY'): string => {
  const text = value === null || value === undefined ? '' : String(value);
  if (!PICKER_DATE_TEXT.test(text)) {
    return text;
  }
  const date = new Date(text);
  return Number.isNaN(date.getTime()) ? text : moment(date).format(format);
};

export default pickerDisplayValue;
